export default "__VITE_ASSET__8nSTyl2r__"